import { BOTTOM_NAV } from '_constants';

const changeActiveItem = (currItem) => dispatch => {
  dispatch({
    type: BOTTOM_NAV.UPDATE_ACTIVE_ITEM,
    activeItem: currItem
  });
};

export const bottomnavActions = {
  changeActiveItem
};
